import styled from "@emotion/styled";

export const Title = styled.h2`
  margin-bottom: 40px;
  font-size: 26px;
  font-weight: 600;
  text-align: ${p => p.textAlign};
  color: ${p => p.theme.colors.secondary.title};

  @media (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-bottom: ${p => p.theme.space[8]}px;
    font-size: 42px;
    font-weight: 700;
  }

  ${props => props.addStyles};
`;
